import React, { useState } from "react";
import {
  Box,
  Button,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from "@mui/material";
import ReviewHistoryGridComponent from "./Grids/ReviewHistoryGrid";

const CTReviewsDrawerContent = ({
  policyKey,
  healthPlanKey,
  closeDrawer,
  ctReviewRows,
  reviewData = {},
  setReviewData, // Function to update parent state
  editable = true,
}) => {
  const [commentValidationOnFail, setCommentValidationOnFail] = useState(false);

  const handleDrawerClick = () => {
    if (!editable) return;
    if (reviewData.results === "fail" && !reviewData.comments?.trim()) {
      setCommentValidationOnFail(true);
    }
  };
  const handleCloseDrawer = () => {
    if (
      editable &&
      reviewData.results === "fail" &&
      !reviewData.comments?.trim()
    ) {
      setCommentValidationOnFail(true);
      return; // Prevent closing if validation fails
    }
    closeDrawer();
  };

  const commonBoxProps = {
    sx: {
      display: "flex",
      flexDirection: "row",
      mt: 1,
      gap: 1,
      alignItems: "flex-start",
      textAlign: "left",
    },
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        height: "100vh",
        ml: "10px",
        mr: "5px",
      }}
      onClick={handleDrawerClick}
    >
      {/* Title */}
      <Typography variant="h4" fontWeight="bold" mt={2} mb={2}>
        C&T Reviews
      </Typography>

      {/* Upload section */}
      <Box sx={{ mt: 1, mb: 2 }}>
        <Box {...commonBoxProps}>
          <Typography
            component="span"
            fontWeight="bold"
            whiteSpace="nowrap"
            sx={{ flex: 0.2 }}
          >
            Type of Review:
          </Typography>
          <Typography sx={{ flex: 1 }} component="span">
            {reviewData.reviewType}
          </Typography>
        </Box>

        <Box {...commonBoxProps}>
          <Typography
            component="span"
            fontWeight="bold"
            whiteSpace="nowrap"
            sx={{ flex: 0.2, marginTop: "10px" }}
          >
            Results:
          </Typography>
          <Box sx={{ flex: 1 }}>
            <RadioGroup
              row
              value={reviewData.results || ""}
              onChange={(e) => {
                if (!editable) return;
                setReviewData((prev) => ({
                  ...prev,
                  results: e.target.value,
                }));
                if (e.target.value === "fail") {
                  setCommentValidationOnFail(true);
                } else {
                  setCommentValidationOnFail(false);
                }
              }}
            >
              <FormControlLabel
                value="pass"
                control={<Radio />}
                label="Pass"
                disabled={!editable}
              />
              <FormControlLabel
                value="fail"
                control={<Radio />}
                label="Fail"
                disabled={!editable}
              />
              <FormControlLabel
                value="inProgress"
                control={<Radio />}
                label="In Progress"
                disabled={!editable}
              />
            </RadioGroup>
          </Box>
        </Box>

        <Box {...commonBoxProps}>
          <Typography
            sx={{ flex: 0.2, marginTop: "10px" }}
            component="span"
            fontWeight="bold"
            whiteSpace="nowrap"
          >
            Comments:
          </Typography>
          <TextField
            sx={{ flex: 1 }}
            placeholder="Comment text to add to the review"
            value={reviewData.comments || ""}
            onChange={(e) => {
              if (!editable) return;
              setReviewData((prev) => ({ ...prev, comments: e.target.value }));
            }}
            error={
              commentValidationOnFail &&
              reviewData.results === "fail" &&
              !reviewData.comments?.trim()
            }
            helperText={
              commentValidationOnFail &&
              reviewData.results === "fail" &&
              !reviewData.comments?.trim()
                ? "Comments are required when selecting 'Fail'"
                : ""
            }
            disabled={!editable}
          />
        </Box>
      </Box>

      {/* Review History */}
      <Typography fontWeight="bold" variant="h5">
        Review History
      </Typography>
      <Box sx={{ flexGrow: 1, overflow: "auto" }}>
        <ReviewHistoryGridComponent rows={ctReviewRows} />
      </Box>

      {/* Close Button */}
      <Box
        sx={{
          mb: 2,
          minHeight: "70px",
          textAlign: "right",
        }}
      >
        <Button
          onClick={handleCloseDrawer}
          variant="text"
          sx={{ fontWeight: "bold" }}
          disabled={
            editable &&
            reviewData.results === "fail" &&
            !reviewData.comments?.trim()
          }
        >
          CLOSE
        </Button>
      </Box>
    </Box>
  );
};

export default CTReviewsDrawerContent;
